import { getUID } from '@redviking/argonaut-util/src/getUID';
import { accessor } from '@redviking/argonaut-core-ui/src/store';
import { performanceFeatureFlags } from '@redviking/argonaut-util/src/feature-flags';
import { FisDataTimingEnum } from '@redviking/argonaut-util/types/db-enums/fis';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import type { NodeSpec } from './NodeSpec';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

const coreStateDataLabelId = '74127943-ce8a-47c0-89fd-c65d174072f2';

export const performanceDataCollectUiNodeSpec: NodeSpec<NodeCfg<'performanceDataCollect'>> = {
    requiredSockets: [ 'trigger', 'numericValue' ],
    cfg: () => ({
        disabled: false,
        controlValues: { dataLabelId: coreStateDataLabelId, timing: FisDataTimingEnum.Start, assetCfg: { id: '' } },
        id: getUID(),
        kind: 'performanceDataCollect',
        width: 220,
    }),
    controls: nodeCfg => ({
        assetCfg: defineControlOpts({ cfg: { kind: 'asset', label: 'Asset' }, on: { 'update:value': defaultControlUpdateValueHandler }, value: nodeCfg.controlValues.assetCfg }),
        dataLabelId: defineControlOpts({
            cfg: {
                kind: 'performanceDataCollectDataLabelId',
                label: 'Data Label',
            },
            on: {
                'update:value': () => {}, // no-op, we only care about the select event
                'select': (dataLabel, { flowEventEmitter }) => flowEventEmitter.emit('updateNodeCfg', { newNodeCfg: { ...nodeCfg, controlValues: { ...nodeCfg.controlValues, dataLabelId: dataLabel.id } } }),
            },
            value: nodeCfg.controlValues.dataLabelId,
        }),
    }),
    inputs: nodeCfg => ({
        trigger: { socket: 'event', label: 'Trigger' },
        numericValue: {
            controlOpts: defineControlOpts({ cfg: { kind: 'number' }, on: { 'update:value': defaultControlUpdateValueHandler }, value: nodeCfg.socketDefaults?.inputs?.numericValue }),
            socket: 'number',
            label: 'Numeric Value',
        },
    }),
    kindLabel: 'Performance Data Collect',
    nodeCategory: 'argonautApi',
    outputs: () => ({ next: { socket: 'event', label: 'Next' } }),
    suppressNode: () => !accessor.testFeatureFlagRequirements([ { or: performanceFeatureFlags } ]),
    validator: node => {
        const errors: Record<string, string> = {};
        if (!node.controlValues.dataLabelId) {
            errors.dataLabelId = 'Data Label is required';
        }
        if ('id' in node.controlValues.assetCfg ? !node.controlValues.assetCfg.id : !node.controlValues.assetCfg.deployParamId) {
            errors.assetCfg = 'Asset is required';
        }
        return Object.keys(errors).length ? errors : true;
    },
};
